<template>

    <section class="section">
        <div class="container">
            <h1 class="title has-text-centered">
                Charge
            </h1>
            <div class="field">
                <b-switch v-model="isRounded">
                    Arrondir les valeurs
                </b-switch>
            </div>

            <hr>

            <!-- Boites -->
            <div class="columns">

                <div class="column is-one-quarter">
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title">
                                Reste à financer
                            </p>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <span class="title h1">{{ resteTotalJours }} jours</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="column">
                    <div class="card">
                      <header class="card-header">
                        <p class="card-header-title">
                          Légende
                        </p>
                      </header>
                      <div class="card-content">
                        <div class="content">
                          <span class="tag is-warning">
                            <b>Nombre positif en orange</b>
                          </span> = Sous-affection <br>
                          <span class="tag is-success">
                            <b>Nombre nul ou négatif en vert</b>
                          </span> = Affection correcte ou légèrement supérieure de maximum 15% <br>
                          <span class="tag is-danger">
                            <b>Nombre négatif en rouge</b>
                          </span> = Suraffectation de +15% par rapport au jours disponibles <br>
                          <b-icon
                              icon="exclamation-circle"
                              type="is-danger"
                              size="is-small">
                          </b-icon> = Cet icone indique qu'il y a une sur-affectation
                        </div>
                      </div>
                    </div>
                </div>
            </div>

            <hr>

            <section>
                <b-table
                        :data="data"
                        ref="table"
                        detailed
                        hoverable
                        custom-detail-row
                        detail-key="service"
                        show-detail-icon
                        >

                    <b-table-column
                            field="name"
                            label="Nom"
                            sortable
                            v-slot="props"
                    >
                        <b-icon
                                icon="building"
                                size="is-small">
                        </b-icon> &nbsp;
                        <b>{{ props.row.service }}</b>
                    </b-table-column>

                    <b-table-column
                            field="sold"
                            label="Jours financés 2026"
                            sortable
                            centered
                            v-slot="props"
                    >
                        <b>{{ props.row.days }}</b>
                    </b-table-column>

                    <b-table-column
                        field="report"
                        label="dont report"
                        sortable
                        centered
                        v-slot="props"
                    >
                      <b>{{ props.row.report }}</b>
                    </b-table-column>

                    <b-table-column
                            field="available"
                            label="Jours à financer"
                            sortable
                            centered
                            v-slot="props"
                    >
                        <b>{{ isRounded ? roundHalf(props.row.daystospend) : props.row.daystospend }}</b>
                    </b-table-column>

                    <b-table-column
                            field="delta"
                            label="Reste à financer 2026 (j)"
                            sortable
                            centered
                            v-slot="props">
                        <span :class="
                                      [
                                          'tag',
                                          getColor(props.row)
                                      ]
                                      ">
                            <b>{{ isRounded ? roundHalf(props.row.daystospend - props.row.days) : props.row.daystospend - props.row.days }}</b>
                        </span>
                        &nbsp;
                        <b-icon
                            v-if="(props.row.daystospend - props.row.days) < 0"
                            icon="exclamation-circle"
                            type="is-danger"
                            size="is-small">
                        </b-icon>
                    </b-table-column>

                    <b-table-column
                            label="Pourcentage de financement"
                            centered
                            v-slot="props"
                    >
                        <b-progress :type="[getColor(props.row)]"
                                    :value="Math.round((props.row.days / props.row.daystospend) * 100)"
                                    show-value>
                            {{ isRounded ? Math.round((props.row.days / props.row.daystospend) * 100) : (props.row.days / props.row.daystospend) * 100 }} % de financé
                        </b-progress>

                    </b-table-column>

                    <template slot="detail" slot-scope="props">
                        <tr v-for="item in props.row.salaries" :key="item.name">
                            <td></td>
                            <td class="has-text-centered pointer"
                                @click.prevent="getDetail(item.name)">
                                {{ item.name }}
                            </td>
                            <td class="has-text-centered">{{ item.days }}</td>
                            <td class="has-text-centered">{{ item.report }}</td>
                            <td class="has-text-centered">{{ isRounded ? roundHalf(item.daystospend) : item.daystospend }}</td>
                            <td class="has-text-centered">
                              <span
                                :class="['tag', getColor(item)]"
                              >
                                {{ isRounded ? roundHalf(item.daystospend - item.days) : item.daystospend - item.days }}

                              </span>
                              &nbsp;
                              <b-icon
                                  v-if="(item.daystospend - item.days) < 0"
                                  icon="exclamation-circle"
                                  type="is-danger"
                                  size="is-small">
                              </b-icon>

                            </td>
                            <td class="has-text-centered">
                                <b-progress :type="[getColor(item)]"
                                            :value="Math.round((item.days / item.daystospend) * 100)"
                                            show-value>
                                    {{ Math.round((item.days / item.daystospend) * 100) }} % de financé
                                </b-progress>
                            </td>
                        </tr>
                    </template>
                </b-table>
            </section>

            <b-modal :active.sync="isSalarieModalActive"
                     has-modal-card
                     full-screen>
                <ChargeSalarie
                        :detailSalarie="detailSalarie">
                </ChargeSalarie>
            </b-modal>

        </div>
    </section>
</template>

<script>
    import ChargeSalarie from "./ChargeSalarie";
    export default {
        name: "Charge",
        components: {ChargeSalarie},
        mounted() {
            this.getCharge();
        },
        computed: {
            resteTotalJours() {
                let sum = 0;
                this.data.forEach(d => {
                    sum += d.daystospend - d.days
                })
                return Math.round(sum);
            }
        },
        data() {
            return {
                data: [],
                detailSalarie: [],
                isSalarieModalActive: false,
                isRounded: true
            }
        },
        methods: {
            getColor(row) {
                console.log(row);
                let delta = row.daystospend - row.days
                let buffer = 0 - (row.daystospend * 0.15) // buffer +15% cf. Pierre
                if (delta > 0 ) {
                  return 'is-warning';
                } else if (delta < 0 && delta > buffer) {
                  return 'is-success';
                } else {
                  return 'is-danger';
                }
            },
            getDetail(s) {
                this.$axios.get(`charge?salarie=${s}`)
                    .then(function (response) {

                        this.detailSalarie = response.data;
                        this.isSalarieModalActive = true;
                    }.bind(this))
                    .catch(error => console.log(error));
            },
            getCharge() {
                this.$axios.get('charges')
                    .then(function (response) {
                        this.data = response.data.charges;
                        // console.log(response.data)
                    }.bind(this))
                    .catch(error => console.log(error));
            },
        }
    }
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }
</style>
